export function servicios(state) {
  if (state.servicios && typeof state.servicios === "object" && state.servicios.constructor === Array) {
    return state.servicios;
  }

  return [];
}

export function necesitaRecargar(state){
  return state.necesitaRecargar;
}

export function filtroVuex(state) {
  if (state.filtro) {
    return state.filtro;
  }
  return {
    FechaInicio: obtenerFechaInicio(), //this.obtenerFechaTest(),//
    FechaFin: obtenerFechaFin(), //this.obtenerFechaTest()//
    Estados: [],
    Poblacion: "",
    Referencia: "",
    Numero: ""
  };
}

function obtenerFechaInicio() {
  const toTwoDigits = num => (num < 10 ? "0" + num : num);
  var date = new Date();
  date.setDate(date.getDate() - 2); // -3 días
  let year = date.getFullYear();
  let month = toTwoDigits(date.getMonth() + 1);
  let day = toTwoDigits(date.getDate());
  return `${year}-${month}-${day}`;
}

function obtenerFechaFin() {
  let date = new Date();
  date.setDate(date.getDate() + 4); // +4 días
  const toTwoDigits = num => (num < 10 ? "0" + num : num);
  let year = date.getFullYear();
  let month = toTwoDigits(date.getMonth() + 1);
  let day = toTwoDigits(date.getDate());
  return `${year}-${month}-${day}`;
}
